import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn'
import { Box, Container, Link, Typography } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useContext } from 'react'
import nl2br from 'react-nl2br'
import { Link as RouterLink } from "react-router-dom"
import Heading from '../../components/Heading'
import { AppContext } from '../../context/AppContextProvider'

const useStyles = makeStyles((theme) => ({
    box: {
        marginTop: theme.spacing(3),
    },
}))

export default function Welcome(props) {
    const { paths, store, features, user } = useContext(AppContext)
    const classes = useStyles()

    return (
        <Container maxWidth="xs">
            <Heading icon={<AssignmentTurnedInIcon />}>
                Welcome, {user.firstName}!
            </Heading>
            <Box spacing={2} className={classes.box}>
                <Typography paragraph>Welcome to the {store.name} {features.custom_display_caregiver} portal!</Typography>

                <Typography variant="h5" gutterBottom>1. <Link component={RouterLink} to={`${paths.leadForm}?caregiver=${encodeURIComponent(user.email)}`} underline="hover">Refer a New Patient</Link></Typography>
                <Typography paragraph>Refer a new patient to the clinic/center.</Typography>

                <Typography variant="h5" gutterBottom>2. <Link component={RouterLink} to={paths.book} underline="hover">Book a Referred Patient</Link></Typography>
                <Typography paragraph>Book an appointment for a previously referred patient.</Typography>

                <Typography variant="h5" gutterBottom>3. <Link component={RouterLink} to={paths.patients} underline="hover">Referred Patients</Link></Typography>
                <Typography paragraph>View patients that you've referred to the clinic/center.</Typography>

                <Typography variant="h5" gutterBottom>4. <Link component={RouterLink} to={paths.caregiverQRCodes} underline="hover">QR Codes</Link></Typography>
                <Typography paragraph>View or print QR Codes.</Typography>

                <Typography variant="h5" gutterBottom>Clinic/Center Information</Typography>
                <Typography paragraph>
                    {store.name}<br />
                    {nl2br(store.address)}<br />
                </Typography>
                <Typography paragraph>
                    Phone: {store.phone_number}<br />
                    Email: <Link href={`mailto:${store.email_address}`} underline="hover">{store.email_address}</Link><br />
                </Typography>
            </Box>
        </Container>
    )
}
